module.exports = __webpack_public_path__ + "img/144.5a83de9b.jpg";